import { render, staticRenderFns } from "./AdminApps.vue?vue&type=template&id=c288aaae&scoped=true&"
import script from "./AdminApps.vue?vue&type=script&lang=ts&"
export * from "./AdminApps.vue?vue&type=script&lang=ts&"
import style0 from "./AdminApps.vue?vue&type=style&index=0&id=c288aaae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c288aaae",
  null
  
)

export default component.exports